import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import ProviderReceiptReportListComponent from "components/ProviderReports/Receipt"
import {
  exportProviderReceiptReport,
  getProviderReceiptReports,
} from "store/provider-reports/p-report-action"
import {
  getProviderItemCategories,
  getProviderFundCodes,
  getProviderCommodityClassifications,
  getProviderShipments,
  getProviderWarehouses,
  getProviderCurrencies,
} from "store/provider-dashboard/provider-dashboard-action"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

const ProviderReceiptReportList = () => {
  document.title = "Receipt Reports"

  const dispatch = useDispatch()
  const receipts = useSelector(
    state => state.providerReports.providerReceiptsReport
  )
  const exportStatus = useSelector(
    state => state.providerReports.providerExportReceiptReport
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_RECEIPT
  )

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onPageClick = link => {
    dispatch(
      getProviderReceiptReports(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => ({ ...prev, order: value.order }))
    }
    if (value.name) {
      setAccording(prev => ({ ...prev, name: value.name }))
    }
  }

  useSearch(
    getProviderReceiptReports(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  useEffect(() => {
    dispatch(
      getProviderReceiptReports(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderShipments())
    dispatch(getProviderFundCodes())
    dispatch(getProviderCommodityClassifications())
    dispatch(getProviderWarehouses())
    dispatch(getProviderCurrencies())
  }, [])

  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProviderReceiptReports(undefined, undefined, undefined, search, data)
    )
  }

  const onExportBtnClick = () => {
    dispatch(
      exportProviderReceiptReport(
        pageNumber,
        according,
        search,
        advnacedSearch,
        visibleKeys
      )
    )
  }

  return (
    <>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Receipt Reports"} />
      <ProviderReceiptReportListComponent
        data={receipts?.data}
        error={receipts?.error}
        loading={receipts?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </>
  )
}

export default ProviderReceiptReportList
